<template>
  <div
    class="create-campaign-product-card"
    :aria-disabled="disabled ? 'true' : 'false'"
    :tabindex="disabled ? -1 : 0"
    @keypress.space.prevent="handleUserKeypress"
    @keypress.enter.prevent="handleUserKeypress"
    @keydown.left="onLeftKeypress"
    @keydown.right="onRightKeypress"
  >
    <div class="create-campaign-product-card__image">
      <img
        :src="productImage"
        :alt="name"
        @error="showDefaultImage = true"
      >

      <div class="create-campaign-product-card__image-overlay" @click="handleClick">
        <div v-if="disabled" class="create-campaign-product-card__badge">
          Item is non-eGiftable
        </div>

        <span v-else>{{ isSelected ? removeButtonText : addButtonText }}</span>
      </div>

      <div class="create-campaign-product-card__options">
        <div v-if="inventoryProduct" class="create-campaign-product-card__options-inventory">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            width="24"
            height="24"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.03 1.21792L16.8846 3.47836C16.9778 3.51139 17.0381 3.60253 17.0325 3.70192V10.3839L21.7146 12.5698C21.8078 12.6028 21.8681 12.694 21.8625 12.7934V19.6492C21.8681 19.7486 21.8078 19.8397 21.7146 19.8728L16.86 22.1332H16.6382L11.9314 19.9473L7.22464 22.1332H7.00286L2.14822 19.8728C2.05505 19.8397 1.99477 19.7486 2.00036 19.6492V12.7934C1.99477 12.694 2.05505 12.6028 2.14822 12.5698L6.83036 10.3839V3.70192C6.82477 3.60253 6.88505 3.51139 6.97822 3.47836L11.8329 1.21792C11.8962 1.19298 11.9666 1.19298 12.03 1.21792ZM11.3154 12.8182L7.05214 10.831L2.83822 12.7934L7.10143 14.7557L11.3154 12.8182ZM11.685 6.1114V12.4456L7.32322 10.4087V4.07452L11.685 6.1114ZM16.5396 4.07452L12.1779 6.1114V12.4456L16.5396 10.4087V4.07452ZM7.34786 15.2028L11.685 13.1908V19.5002L7.34786 21.5122V15.2028ZM16.515 15.2028L12.1779 13.1908V19.5002L16.515 21.5122V15.2028ZM16.7614 14.7557L12.5475 12.8182L16.8107 10.831L21.0246 12.7934L16.7614 14.7557ZM16.1946 3.70192L11.9314 1.71472L7.66822 3.70192L11.9314 5.68912L16.1946 3.70192ZM2.49322 13.166L6.855 15.2028V21.5122L2.49322 19.5002V13.166ZM17.0079 15.2028V21.5122L21.3696 19.5002V13.166L17.0079 15.2028Z"
              fill="currentColor"
            />
            <path
              d="M16.8846 3.47836L16.7791 3.705L16.7899 3.71002L16.8011 3.714L16.8846 3.47836ZM12.03 1.21792L12.1355 0.991288L12.1286 0.988074L12.1215 0.985286L12.03 1.21792ZM17.0325 3.70192L16.7825 3.68786V3.70192H17.0325ZM17.0325 10.3839H16.7825V10.5431L16.9267 10.6104L17.0325 10.3839ZM21.7146 12.5698L21.6089 12.7963L21.6198 12.8014L21.6311 12.8054L21.7146 12.5698ZM21.8625 12.7934L21.6125 12.7793V12.7934H21.8625ZM21.8625 19.6492H21.6121L21.6129 19.6632L21.8625 19.6492ZM21.7146 19.8728L21.6311 19.6371L21.6199 19.6411L21.6091 19.6461L21.7146 19.8728ZM16.86 22.1332V22.3832H16.9154L16.9655 22.3598L16.86 22.1332ZM16.6382 22.1332L16.5329 22.3599L16.583 22.3832H16.6382V22.1332ZM11.9314 19.9473L12.0367 19.7205L11.9314 19.6716L11.8261 19.7205L11.9314 19.9473ZM7.22464 22.1332V22.3832H7.27986L7.32995 22.3599L7.22464 22.1332ZM7.00286 22.1332L6.89733 22.3598L6.94751 22.3832H7.00286V22.1332ZM2.14822 19.8728L2.25374 19.6461L2.24295 19.6411L2.23174 19.6371L2.14822 19.8728ZM2.00036 19.6492L2.25036 19.6633V19.6492H2.00036ZM2.00036 12.7934H2.25075L2.24996 12.7793L2.00036 12.7934ZM2.14822 12.5698L2.23174 12.8054L2.24308 12.8014L2.25397 12.7963L2.14822 12.5698ZM6.83036 10.3839L6.93612 10.6104L7.08036 10.5431V10.3839H6.83036ZM6.83036 3.70192H7.08075L7.07996 3.68788L6.83036 3.70192ZM6.97822 3.47836L7.06174 3.714L7.07295 3.71002L7.08374 3.705L6.97822 3.47836ZM11.8329 1.21792L11.7413 0.985286L11.7342 0.988074L11.7273 0.991288L11.8329 1.21792ZM7.05214 10.831L7.15777 10.6044L7.05219 10.5552L6.94661 10.6044L7.05214 10.831ZM11.3154 12.8182L11.4198 13.0453L11.9104 12.8198L11.421 12.5916L11.3154 12.8182ZM2.83822 12.7934L2.73268 12.5667L2.24318 12.7947L2.73368 13.0205L2.83822 12.7934ZM7.10143 14.7557L6.9969 14.9828L7.10137 15.0309L7.20587 14.9829L7.10143 14.7557ZM11.685 12.4456L11.5792 12.6721L11.935 12.8383V12.4456H11.685ZM11.685 6.1114H11.935V5.95223L11.7908 5.88489L11.685 6.1114ZM7.32322 10.4087H7.07322V10.5679L7.21744 10.6352L7.32322 10.4087ZM7.32322 4.07452L7.429 3.84801L7.07322 3.68186V4.07452H7.32322ZM12.1779 6.1114L12.0721 5.88489L11.9279 5.95223V6.1114H12.1779ZM16.5396 4.07452H16.7896V3.68186L16.4339 3.84801L16.5396 4.07452ZM12.1779 12.4456H11.9279V12.8383L12.2836 12.6721L12.1779 12.4456ZM16.5396 10.4087L16.6454 10.6352L16.7896 10.5679V10.4087H16.5396ZM11.685 13.1908H11.935V12.7992L11.5798 12.964L11.685 13.1908ZM7.34786 15.2028L7.24265 14.9761L7.09786 15.0432V15.2028H7.34786ZM11.685 19.5002L11.7902 19.727L11.935 19.6598V19.5002H11.685ZM7.34786 21.5122H7.09786V21.9038L7.45307 21.739L7.34786 21.5122ZM12.1779 13.1908L12.2831 12.964L11.9279 12.7992V13.1908H12.1779ZM16.515 15.2028H16.765V15.0432L16.6202 14.9761L16.515 15.2028ZM12.1779 19.5002H11.9279V19.6598L12.0727 19.727L12.1779 19.5002ZM16.515 21.5122L16.4098 21.739L16.765 21.9038V21.5122H16.515ZM12.5475 12.8182L12.4419 12.5916L11.9524 12.8198L12.4431 13.0453L12.5475 12.8182ZM16.7614 14.7557L16.657 14.9829L16.7615 15.0309L16.866 14.9828L16.7614 14.7557ZM16.8107 10.831L16.9163 10.6044L16.8107 10.5552L16.7051 10.6044L16.8107 10.831ZM21.0246 12.7934L21.1292 13.0205L21.6197 12.7947L21.1302 12.5667L21.0246 12.7934ZM11.9314 1.71472L12.0371 1.48813L11.9314 1.4389L11.8258 1.48813L11.9314 1.71472ZM16.1946 3.70192L16.3003 3.92852L16.7864 3.70192L16.3003 3.47533L16.1946 3.70192ZM7.66822 3.70192L7.56259 3.47533L7.07648 3.70192L7.56259 3.92852L7.66822 3.70192ZM11.9314 5.68912L11.8258 5.91572L11.9314 5.96495L12.0371 5.91572L11.9314 5.68912ZM6.855 15.2028H7.105V15.0437L6.96078 14.9763L6.855 15.2028ZM2.49322 13.166L2.599 12.9394L2.24322 12.7733V13.166H2.49322ZM6.855 21.5122L6.75028 21.7392L7.105 21.9028V21.5122H6.855ZM2.49322 19.5002H2.24322V19.6602L2.3885 19.7272L2.49322 19.5002ZM17.0079 21.5122H16.7579V21.9028L17.1126 21.7392L17.0079 21.5122ZM17.0079 15.2028L16.9021 14.9763L16.7579 15.0437V15.2028H17.0079ZM21.3696 19.5002L21.4744 19.7272L21.6196 19.6602V19.5002H21.3696ZM21.3696 13.166H21.6196V12.7733L21.2639 12.9394L21.3696 13.166ZM16.9902 3.25173L12.1355 0.991288L11.9245 1.44456L16.7791 3.705L16.9902 3.25173ZM17.2821 3.71597C17.2939 3.5068 17.167 3.31322 16.9682 3.24273L16.8011 3.714C16.7886 3.70955 16.7823 3.69826 16.7829 3.68788L17.2821 3.71597ZM17.2825 10.3839V3.70192H16.7825V10.3839H17.2825ZM21.8204 12.3433L17.1383 10.1574L16.9267 10.6104L21.6089 12.7963L21.8204 12.3433ZM22.1121 12.8074C22.1239 12.5982 21.997 12.4047 21.7982 12.3342L21.6311 12.8054C21.6186 12.801 21.6123 12.7897 21.6129 12.7793L22.1121 12.8074ZM22.1125 19.6492V12.7934H21.6125V19.6492H22.1125ZM21.7982 20.1084C21.997 20.0379 22.1239 19.8443 22.1121 19.6352L21.6129 19.6632C21.6123 19.6529 21.6186 19.6416 21.6311 19.6371L21.7982 20.1084ZM16.9655 22.3598L21.8202 20.0994L21.6091 19.6461L16.7545 21.9066L16.9655 22.3598ZM16.6382 22.3832H16.86V21.8832H16.6382V22.3832ZM11.8261 20.174L16.5329 22.3599L16.7435 21.9065L12.0367 19.7205L11.8261 20.174ZM7.32995 22.3599L12.0367 20.174L11.8261 19.7205L7.11934 21.9065L7.32995 22.3599ZM7.00286 22.3832H7.22464V21.8832H7.00286V22.3832ZM2.04269 20.0994L6.89733 22.3598L7.10839 21.9066L2.25374 19.6461L2.04269 20.0994ZM1.75075 19.6352C1.73898 19.8443 1.86582 20.0379 2.06469 20.1084L2.23174 19.6371C2.24428 19.6416 2.25055 19.6529 2.24996 19.6632L1.75075 19.6352ZM1.75036 12.7934V19.6492H2.25036V12.7934H1.75036ZM2.06469 12.3342C1.86582 12.4047 1.73898 12.5982 1.75075 12.8074L2.24996 12.7793C2.25055 12.7897 2.24428 12.801 2.23174 12.8054L2.06469 12.3342ZM6.7246 10.1574L2.04246 12.3433L2.25397 12.7963L6.93612 10.6104L6.7246 10.1574ZM6.58036 3.70192V10.3839H7.08036V3.70192H6.58036ZM6.89469 3.24273C6.69582 3.31322 6.56898 3.5068 6.58075 3.71597L7.07996 3.68788C7.08055 3.69826 7.07428 3.70956 7.06174 3.714L6.89469 3.24273ZM11.7273 0.991288L6.87269 3.25173L7.08374 3.705L11.9384 1.44456L11.7273 0.991288ZM12.1215 0.985286C11.9993 0.937196 11.8635 0.937197 11.7413 0.985286L11.9244 1.45056C11.929 1.44877 11.9339 1.44877 11.9385 1.45056L12.1215 0.985286ZM6.94652 11.0576L11.2097 13.0448L11.421 12.5916L7.15777 10.6044L6.94652 11.0576ZM2.94375 13.02L7.15768 11.0576L6.94661 10.6044L2.73268 12.5667L2.94375 13.02ZM7.20596 14.5286L2.94275 12.5663L2.73368 13.0205L6.9969 14.9828L7.20596 14.5286ZM11.2109 12.5911L6.99699 14.5286L7.20587 14.9829L11.4198 13.0453L11.2109 12.5911ZM11.935 12.4456V6.1114H11.435V12.4456H11.935ZM7.21744 10.6352L11.5792 12.6721L11.7908 12.2191L7.429 10.1822L7.21744 10.6352ZM7.07322 4.07452V10.4087H7.57322V4.07452H7.07322ZM11.7908 5.88489L7.429 3.84801L7.21744 4.30104L11.5792 6.33792L11.7908 5.88489ZM12.2836 6.33792L16.6454 4.30104L16.4339 3.84801L12.0721 5.88489L12.2836 6.33792ZM12.4279 12.4456V6.1114H11.9279V12.4456H12.4279ZM16.4339 10.1822L12.0721 12.2191L12.2836 12.6721L16.6454 10.6352L16.4339 10.1822ZM16.2896 4.07452V10.4087H16.7896V4.07452H16.2896ZM11.5798 12.964L7.24265 14.9761L7.45307 15.4296L11.7902 13.4176L11.5798 12.964ZM11.935 19.5002V13.1908H11.435V19.5002H11.935ZM7.45307 21.739L11.7902 19.727L11.5798 19.2734L7.24265 21.2854L7.45307 21.739ZM7.09786 15.2028V21.5122H7.59786V15.2028H7.09786ZM12.0727 13.4176L16.4098 15.4296L16.6202 14.9761L12.2831 12.964L12.0727 13.4176ZM12.4279 19.5002V13.1908H11.9279V19.5002H12.4279ZM16.6202 21.2854L12.2831 19.2734L12.0727 19.727L16.4098 21.739L16.6202 21.2854ZM16.265 15.2028V21.5122H16.765V15.2028H16.265ZM12.4431 13.0453L16.657 14.9829L16.8659 14.5286L12.6519 12.5911L12.4431 13.0453ZM16.7051 10.6044L12.4419 12.5916L12.6531 13.0448L16.9163 11.0576L16.7051 10.6044ZM21.1302 12.5667L16.9163 10.6044L16.7052 11.0576L20.9191 13.02L21.1302 12.5667ZM16.866 14.9828L21.1292 13.0205L20.9201 12.5663L16.6569 14.5286L16.866 14.9828ZM11.8258 1.94132L16.089 3.92852L16.3003 3.47533L12.0371 1.48813L11.8258 1.94132ZM7.77384 3.92852L12.0371 1.94132L11.8258 1.48813L7.56259 3.47533L7.77384 3.92852ZM12.0371 5.46253L7.77384 3.47533L7.56259 3.92852L11.8258 5.91572L12.0371 5.46253ZM16.089 3.47533L11.8258 5.46253L12.0371 5.91572L16.3003 3.92852L16.089 3.47533ZM6.96078 14.9763L2.599 12.9394L2.38744 13.3925L6.74922 15.4294L6.96078 14.9763ZM7.105 21.5122V15.2028H6.605V21.5122H7.105ZM2.3885 19.7272L6.75028 21.7392L6.95972 21.2852L2.59793 19.2732L2.3885 19.7272ZM2.24322 13.166V19.5002H2.74322V13.166H2.24322ZM17.2579 21.5122V15.2028H16.7579V21.5122H17.2579ZM21.2649 19.2732L16.9031 21.2852L17.1126 21.7392L21.4744 19.7272L21.2649 19.2732ZM21.1196 13.166V19.5002H21.6196V13.166H21.1196ZM17.1136 15.4294L21.4754 13.3925L21.2639 12.9394L16.9021 14.9763L17.1136 15.4294Z"
              fill="currentColor"
            />
          </svg>
        </div>

        <div class="create-campaign-product-card__options-action">
          <template v-if="showSelectedIcon">
            <icons-check-circle
              v-if="isSelected"
              filled
              :width="30"
              :height="30"
              filled-color="#6E50FF"
              :check-stroke-width="1.5"
            />

            <svg
              v-else-if="!isSelected && $vuetify.breakpoint.xsOnly"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.8235 28.5318C22.3199 28.5318 28.397 22.4547 28.397 14.9583C28.397 7.46183
                  22.3199 1.38477 14.8235 1.38477C7.32706 1.38477 1.25 7.46183 1.25 14.9583C1.25
                  22.4547 7.32706 28.5318 14.8235 28.5318Z"
                fill="white"
                stroke="#6E50FF"
                stroke-width="1.5"
              />
              <path d="M8.75 14.8105L21.574 14.8103" stroke="#6E50FF" stroke-width="1.5"/>
              <path d="M15.1621 21.2222V8.39844" stroke="#6E50FF" stroke-width="1.5"/>
            </svg>
          </template>
        </div>
      </div>
    </div>

    <div
      v-if="showInventoryProductInfo"
      class="create-campaign-product-card__inventory-product-info"
    >
      <div v-if="stock" class="create-campaign-product-card__stock">
        <div
          class="create-campaign-product-card-stock-item"
          :class="{ 'create-campaign-product-card-stock-item--out-of-stock': stock.qty <= 0 }"
          aria-label="Product Qty"
        >
          {{ stock.qty }}
        </div>
        <div
          class="create-campaign-product-card-stock-item create-campaign-product-card-stock-item--in-production"
          aria-label="Qty in production"
        >
          {{ stock.qty_in_production }}
        </div>
        <div
          class="create-campaign-product-card-stock-item create-campaign-product-card-stock-item--on-hold"
          aria-label="Qty on hold"
        >
          {{ stock.qty_on_hold }}
        </div>
      </div>

      <div
        v-for="variant in productVariants"
        :key="variant.id"
        class="create-campaign-product-card-variant-item"
      >
        {{ variant.qty }} {{ variant.name }} variations
      </div>
    </div>

    <div class="create-campaign-product-card__name">
      {{ name }}
    </div>

    <div class="create-campaign-product-card__info">
      <template v-if="price">
        {{ price | priceFilter }}
      </template>

      <a v-if="url" :href="url" target="_blank" rel="noopener noreferrer">More info</a>

      <cg-button
        v-if="$vuetify.breakpoint.xsOnly && !disabled"
        @click="handleClick"
        outlined
        color="#6E50FF"
        :height="28"
        :font-size="13"
        :line-height="15"
        :font-weight="400"
      >
        {{ isSelected ? 'Remove' : 'Add item' }}
      </cg-button>
    </div>
  </div>
</template>

<script>
import { CgButton } from '@corporategift/design-system'

export default {
  name: 'ProductCard',
  components: { CgButton },
  props: {
    id: {
      type: Number,
      required: true,
    },
    showSelectedIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
    price: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: false,
      default: null,
    },
    inventoryProduct: {
      type: Boolean,
      required: false,
      default: false,
    },
    stock: {
      type: Object,
      required: false,
      default: null,
    },
    variations: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    addButtonText: {
      type: String,
      required: false,
      default: 'Select',
    },
    removeButtonText: {
      type: String,
      required: false,
      default: 'Unselect',
    },
  },
  data: () => ({
    imageUrl: 'https://cf.corporategift.com/media/catalog/product',
    showDefaultImage: false,
  }),
  computed: {
    productImage () {
      const { image, imageUrl, showDefaultImage } = this

      if (!image || showDefaultImage) return '/images/empty-order.png'
      if (image.includes('https://cf')) { return image }

      return image.includes('no_selection') ? '/images/empty-order.png' : imageUrl + image
    },
    showInventoryProductInfo () {
      const { stock, variations } = this

      if (stock) { return true }
      if (variations) { return !!variations.length }
      return false
    },
    productVariants () {
      const { variations } = this

      if (!variations) { return [] }

      const variantsInfo = variations
        .flatMap(({ variants }) => variants)
        .reduce((acc, variant) => {
          const index = acc.findIndex(({ name }) => name === variant.variant);
          if (index !== -1) {
            acc[index].qty += 1;
          } else {
            acc.push({
              id: acc.length,
              name: variant.variant,
              qty: 1,
            });
          }
          return acc;
        }, [])

      return variantsInfo ?? []
    },
  },
  methods: {
    // to fix an issue with the space key when user is currently focusing on the Anchor element
    handleUserKeypress (event) {
      if (!(event.target instanceof HTMLAnchorElement)) {
        this.handleClick();
      }
    },
    onLeftKeypress () {
      const activeElement = document.activeElement

      if (activeElement.previousElementSibling) {
        activeElement.previousElementSibling.focus()
      }
    },
    onRightKeypress () {
      const activeElement = document.activeElement

      if (activeElement.nextElementSibling) {
        activeElement.nextElementSibling.focus()
      }
    },
    handleClick () {
      const { id, isSelected } = this
      this.$emit(isSelected ? 'removeProduct' : 'addProduct', id)
    },
  }
}
</script>

<style lang="scss" scoped>
.create-campaign-product-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  outline: none;
  color: #000;

  &__image {
    position: relative;
    width: 100%;

    & > img {
      object-fit: contain;
      width: 100%;
      aspect-ratio: 1 / 1;
    }
  }

  &__image-overlay {
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    cursor: pointer;
    background-color: transparent;
    transition: background-color ease-in-out 0.2s;

    & > span {
      border-radius: 100px;
      display: none;
      user-select: none;
      border: 2px solid #fff;
      color: #000;
      background-color: #fff;
      font-weight: 400;
      padding: 0 32px;
      height: 40px;
      align-items: center;
      line-height: 22px;
      font-size: 18px;
      font-family: 'Lato', sans-serif;
      box-sizing: border-box;
    }

    &::v-deep > button {
      border-radius: 100px;
      display: none;
      user-select: none;

      &:hover {
        background: #D3D2D2;
        border-color: #D3D2D2;
      }
    }
  }

  &__badge {
    padding: 4px 8px;
    gap: 4px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    color: #DD080E;
    font-family: 'Lato-Bold', sans-serif;
    font-size: 12px;
    letter-spacing: 0.5px;
    border-radius: 4px;
    background-color: #FFEEEF;
    border: 1px solid currentColor;
  }

  &__name {
    font-family: 'Lato-Regular', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  &__info {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    margin-top: auto;
    gap: 24px;
    height: 34px;
    justify-content: space-between;
    align-items: center;
    font-family: 'Lato-Bold', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;

    & > a {
      color: #6E50FF;
      margin-left: auto;
      font-family: 'Lato-Regular', sans-serif;
      font-weight: 400;
      line-height: 34px;
    }

    & > button {
      border-radius: 100px;
      padding: 0 12px;
      margin-left: auto;
    }

    @media screen and (max-width: 430px) {
      & > a {
        display: none;
      }
    }
  }

  &__options {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    gap: 10px;
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  &__options-inventory {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #E5FF83;
    display: flex;
    color: #000;
    align-items: center;
    justify-content: center;
  }

  &__options-action {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__inventory-product-info {
    gap: 8px;
    display: flex;
    flex-direction: column;
  }

  &__stock {
    gap: 4px;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
  }

  &-stock-item {
    height: 28px;
    padding: 0 8px;
    min-width: 28px;
    border-radius: 48px;

    color: #fff;
    font-size: 11px;
    line-height: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #007E76;
    font-family: 'Lato-Bold', sans-serif;

    &--in-production {
      color: #62646A;
      background-color: #ECD884;
    }

    &--on-hold {
      background-color: #D3D2D2;
    }

    &--out-of-stock {
      background-color: #F15B5B;
    }
  }

  &-variant-item {
    border-radius: 4px;
    padding: 4px 8px;
    color: #222325;
    width: fit-content;
    background-color: #E5FF83;
    text-transform: uppercase;

    font-family: 'Lato-Bold', sans-serif;
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0.5px;

    &:nth-child(odd) {
      color: #4E3AAF;
      background-color: #E5DFFF;
    }
  }

  &:hover,
  &:focus-visible {
    & .create-campaign-product-card__image-overlay {
      background-color: #00000026;
      z-index: 1;

      & > span {
        display: flex;
      }

      @media screen and (max-width: 430px) {
        background-color: transparent;

        & > span {
          display: none;
        }
      }
    }

    & .create-campaign-product-card__options-action {
      // & > svg {
      //   display: none;
      // }

      & > div {
        display: flex;
      }

      @media screen and (max-width: 430px) {
        & > svg {
          display: initial;
        }
      }
    }
  }

  &[aria-disabled="true"] {
    & .create-campaign-product-card__image {
      pointer-events: none;

      & > img {
        opacity: 0.5;
      }
    }

    & .create-campaign-product-card__image-overlay {
      background-color: #FFFFFF33;
      cursor: default;
      pointer-events: none;
    }

    & .create-campaign-product-card__options-action {
      display: none;
    }
  }

  @media screen and (max-width: 430px) {
    gap: 6px;

    &__name {
      font-size: 14px;
      line-height: 16px;
    }
  }
}
</style>
